module.exports = __webpack_public_path__ + "img/up2.e050ff2f.png";